import { SoftLockConfig } from './softLocking';
import { VertexFamily } from './types';

/**
 * This file contains configuration to tweak the interactive-snapping behaviors.
 */

/**
 * A foot is twelve inches!
 */
export const FOOT_GRID_INCREMENT_INCHES = 12;

/**
 * The desired snapping radius for the foot grid. Length snapping does not soft lock to grid lines, so it uses this
 *   constant directly.
 */
export const FOOT_GRID_SNAP_RADIUS = 1;

export const ENTITY_SOFT_LOCK = {
  engageDistance: 1.5,
  disengageDistance: 2.5,
  switchMargin: 0.5,
} satisfies SoftLockConfig;

export const GRID_SOFT_LOCK = {
  engageDistance: FOOT_GRID_SNAP_RADIUS,
  disengageDistance: FOOT_GRID_SNAP_RADIUS + 1,
  switchMargin: 1 / 16,
} satisfies SoftLockConfig;

/** Prevents large jumps when dragging the length of a line that's not perpendicular to a snapping target.
 *  Must be >= the configured disengage distances above */
export const MAX_LENGTH_SNAP_DISPLACEMENT = 3.0;

/**
 * Segments nearly perpendicular to a snap axis require a huge displacement to close a small axis gap. This threshold
 *   rejects those cases.
 */
export const MIN_DIRECTION_COMPONENT = 0.1;

/** Controls how quickly vertex candidate weight falls off with distance. Smaller values make the system more tolerant
 *   of distant targets.
 */
export const MOVE_VERTEX_DISTANCE_DECAY = 1 / 32;

/**
 * Higher priority snapping targets will always be chosen over lower priority snapping targets.
 */
export const VERTEX_FAMILY_PRIORITY = {
  entity: 1,
  grid: 0,
} as const satisfies Record<VertexFamily, number>;
